export const setDashboardData = (el = {}) => {
    return {
        total_campuses: el.total_campuses ?? 0,
        total_buildings: el.total_buildings ?? 0,
        total_drones: el.total_drones ?? 0,
        total_staff: el.total_staff ?? 0,
        total_students: el.total_students ?? 0,
        total_parents: el.total_parents ?? 0,
        total_law_enforcement: el.total_law_enforcement ?? 0,
        total_911_dispatchers: el.total_911_dispatchers ?? 0,
        total_users: el.total_users ?? 0,
        location_disabled_users: el.location_disabled_users ?? 0,
        camera_disabled_users: el.camera_disabled_users ?? 0,
        microphone_disabled_users: el.microphone_disabled_users ?? 0,
        notification_disabled_users: el.notification_disabled_users ?? 0,
        onboarding_incomplete_users: el.onboarding_incomplete_users ?? 0,
        fully_permissioned_users: el.fully_permissioned_users ?? 0,
        incidents_by_month: el.incidents_by_month ?? [],
    };
};